<template>
  <app-panel
    title="Address"
    class="container"
    v-on:next="next"
    v-on:prev="prev"
    v-bind:showBack="true"
    v-bind:showNext="true"
  >
    <div class="row">
      <!-- Address Entry -->
      <b-form-group
        v-show="!form.manualEntry"
        class="col-lg-4 col-md-6"
        id="input-group-addr"
        label="Legal Address:"
        label-for="input-addr"
        :description="form.address.state ? `${form.address.to_str()}` : undefined"
      >
        <VueGoogleAutocomplete
          ref="address"
          id="input-addr"
          class="form-control"
          type="text"
          required
          placeholder="Search for Address"
          v-on:placechanged="getAddressData"
        ></VueGoogleAutocomplete>
      </b-form-group>
      <b-form-group
        v-show="!form.manualEntry"
        class="col-lg-2 col-md-3"
        id="input-group-addr"
        label="Apt/Suite:"
        label-for="input-addr-line2"
      >
        <b-form-input
          ref="address"
          id="input-addr-line2"
          class="form-control"
          v-model="form.address.addrLine2"
          type="text"
          placeholder="(optional)"
        ></b-form-input>
      </b-form-group>
      <!-- Mail Address Entry -->
      <b-form-group
        v-show="!form.mailAddressSame"
        class="col-lg-4 col-md-6"
        id="input-group-addr"
        label="Mail Address:"
        label-for="input-addr"
        :description="form.mailAddress.state ? `${form.mailAddress.to_str()}` : undefined"
      >
        <VueGoogleAutocomplete
          ref="mail-address"
          id="input-mail-addr"
          class="form-control"
          type="text"
          required="false"
          placeholder="Search for Mail Address"
          v-on:placechanged="getMailAddressData"
        ></VueGoogleAutocomplete>
      </b-form-group>
      <b-form-group
        v-show="!form.mailAddressSame"
        class="col-lg-2 col-md-3"
        id="input-group-addr"
        label="Apt/Suite:"
        label-for="input-addr-line2"
      >
        <b-form-input
          ref="address"
          id="input-addr-line2"
          class="form-control"
          v-model="form.mailAddress.addrLine2"
          type="text"
          placeholder="(optional)"
        ></b-form-input>
      </b-form-group>
    </div>
    <b-form-checkbox
      class="mb-2 mr-sm-2 mb-sm-0"
      v-model="form.mailAddressSame"
      style="padding-bottom: 20px;"
    >Mail Address Same</b-form-checkbox>
    <b-row>
    <b-form-checkbox
      class="mb-2 mr-sm-2 mb-sm-0"
      v-model="form.manualEntry"
      style="padding-bottom: 20px;"
    >Check to manually enter address</b-form-checkbox>
    </b-row>
    <b-row v-show="form.manualEntry">
      <b-form-group
        class="col-lg-5 col-md-6 col-sm-12"
        id="input-group-addr-manual"
        label="Address:"
        label-for="input-addr-manual"
        >
        <b-form-input
          ref="address"
          id="input-addr-manual"
          class="form-control"
          v-model="form.address._addr"
          type="text"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        class="col-lg-4 col-md-6 col-sm-8"
        id="input-group-city-manual"
        label="City:"
        label-for="input-city-manual"
        >
        <b-form-input
          ref="city"
          id="input-city-manual"
          class="form-control"
          v-model="form.address.city"
          type="text"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        class="col-lg-3 col-md-4 col-sm-4"
        id="input-group-state-manual"
        label="State:"
        label-for="input-state-manual">
        <b-form-select v-model="form.address.state" :options="validStateOptions"/>
      </b-form-group>
      <b-form-group
        class="col-lg-3 col-md-4 col-sm-4"
        id="input-group-zip-manual"
        label="Zip Code:"
        label-for="input-zip-manual"
        >
        <b-form-input
          ref="zip"
          id="input-zip-manual"
          class="form-control"
          v-model="form.address.zip"
          type="number"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        class="col-lg-2 col-md-3"
        id="input-group-addr"
        label="Apt/Suite:"
        label-for="input-addr-line2"
      >
        <b-form-input
          ref="address"
          id="input-addr-line2"
          class="form-control"
          v-model="form.mailAddress.addrLine2"
          type="text"
          placeholder="(optional)"
        ></b-form-input>
      </b-form-group>
    </b-row>
    <b-alert show variant="danger" v-for="error in errors" v-bind:key="error">{{error}}</b-alert>
  </app-panel>
</template>

<script>
import appPanel from "./appPanel.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";
function eighteenYearsAgo() {
  let d = new Date();
  d.setFullYear(d.getFullYear() - 18);
  return d;
}
class Address {
  constructor(addr, city, state, zip) {
    this._addr = addr;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.addrLine2 = "";
  }
  get addr() {
    return `${this._addr}, ${this.addrLine2}`;
  }
  set addressData(data) {
    this._addr = `${data.street_number} ${data.route}`;
    this.city = data.locality;
    this.state = data.administrative_area_level_1;
    this.zip = data.postal_code;
  }
  to_str() {
    return this.addr + " " + this.city + ", " + this.state + ", " + this.zip;
  }
  isValid() {
    return (
      this._addr !== undefined &&
      this._addr.length > 0 &&
      (this.city !== undefined && this.city.length > 0) &&
      (this.state !== undefined && this.state.length > 0)
    );
  }
}
export default {
  components: {
    appPanel,
    VueGoogleAutocomplete
  },
  data() {
    return {
      form: {
        address: new Address(),
        mailAddress: new Address(),
        mailAddressSame: true,
        manualEntry: false
      },
      validStates: { NY: 1 },
      validStateOptions: [],
      errors: []
    };
  },
  methods: {
    validate() {
      this.errors = [];
      if (!this.form.address.isValid())
        this.errors.push("Please enter a valid address");
      else if (!this.validStates[this.form.address.state])
        this.errors.push(
          `We are sorry, we currently do not operate the CNC Card in ${this.form.address.state}`
        );
      if (!this.form.mailAddressSame && !this.form.mailAddress.isValid()) {
        this.errors.push("Please enter a valid mail address");
        if (!this.validStates[this.form.mailAddress.state])
          this.errors.push(
            `We are sorry, we currently do not operate the CNC Card in ${this.form.address.state}`
          );
      }
      if (!this.errors.length) return true;
    },
    next() {
      if (this.validate()) {
        let data = {
          currentAddress: this.form.address.addr,
          currentCity: this.form.address.city,
          currentState_id: this.validStates[this.form.address.state],
          currentZip: this.form.address.zip,
          mailAddrSame: this.form.mailAddressSame
        };
        if (!this.form.mailAddressSame) {
          data.mailAddr = this.form.mailAddress.addr;
          data.mailCity = this.form.mailAddress.city;
          data.mailState_id = this.validStates[this.form.mailAddress.state];
          data.mailZip = this.validStates[this.form.mailAddress.zip];
        }
        this.$emit("next", data);
      }
    },
    prev() {
      this.$emit("prev");
    },
    getAddressData(addressData) {
      console.log(addressData);
      this.form.address.addressData = addressData;
    },
    getMailAddressData(addressData) {
      this.form.mailAddress.addressData = addressData;
    }
  },
  mounted() {
    // To demonstrate functionality of exposed component functions
    // Here we make focus on the user input
    this.$refs.address.focus();
    this.axios
      .get("https://apps.retailcreditcloudapi.net/api/online/state/2")
      .then(({ data }) => {
        this.validStates = data.states.reduce((curr, state) => {
          curr[state.abrv] = state.id;
          return curr;
        }, {});
        this.validStateOptions = data.states.reduce((curr, state) => {
          curr.push({value: state.abrv, text: state.name});
          return curr;
        }, []);
      });
  }
};
</script>
<style>
.alert {
  margin-top: 5px;
}
.selectable-input {
  background-color: white !important;
}
.input-group-sep {
  margin-right: -1px;
  margin-left: -1px;
}
.input-group-sep > .input-group-text {
  border-radius: 0;
}
</style>
